import SelectItem from "@/models/components/inputs/selectItem";
import i18n from "@/plugins/i18n";
import { filterCapitalize } from "@/filters/capitalize";

export enum BOOKING_STATUSES {
  NotReady = 0,
  PartiallyReady = 1,
  Ready = 2,
  Blocked = 3,
}

export const translatedStatuses = [
  { value: BOOKING_STATUSES.NotReady, text: filterCapitalize(i18n.t("notReady")) } as SelectItem,
  { value: BOOKING_STATUSES.PartiallyReady, text: filterCapitalize(i18n.t("partialReady")) } as SelectItem,
  { value: BOOKING_STATUSES.Ready, text: filterCapitalize(i18n.t("ready")) } as SelectItem,
  { value: BOOKING_STATUSES.Blocked, text: filterCapitalize(i18n.t("blocked")) } as SelectItem,
];
